module.exports = __webpack_public_path__ + "static/media/more_protection.00928d28.png";